module.exports = __webpack_public_path__ + "static/media/store-top-banner.48b81427.jpg";